<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="section">
        <div class="columns is-vcentered">
          <div class="column is-2 is-offset-2">
            <img :src="`${event.imgUrl}`" style="width: 150px;" />
          </div>
          <div class="column is-6">
            <h1 class="title">{{ event.eventname }}</h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body">
              <div class="has-text-centered has-margin-bottom-30">
                <h2 class="title">View Workouts</h2>
              </div>
              <div v-if="eventworkouts && eventworkouts.workouts.length === 0">
                No workouts available yet.
              </div>
              <div v-if="eventworkouts && eventworkouts.workouts.length > 0">
                <b-tabs>
                  <b-tab-item
                    :key="workout._id"
                    v-for="workout in eventworkouts.workouts"
                    :label="workout.name"
                  >
                    <div v-html="workout.content"></div>
                  </b-tab-item>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WorkoutApi from "@/api/workout";
import EventEntryApi from "@/api/event-entry";
export default {
  components: {},
  name: "ViewWorkouts",
  computed: {
    ...mapGetters(["user"])
  },
  data() {
    return {
      loading: true,
      entry: {},
      event: {},
      eventworkouts: {}
    };
  },
  async created() {
    this.entry = await EventEntryApi.getEventEntry(this.$route.params.id);
    if (this.entry) {
      this.event = this.entry.event;
      this.eventworkouts = await WorkoutApi.workoutsByEvent(
        this.event._id,
        this.entry.entrytype,
        this.entry.category,
        this.user.gender,
        true
      );
    }

    this.loading = false;
  }
};
</script>
